export default "__VITE_ASSET__HZv5mVnG__"